import { Typography } from 'antd';
import React, { ReactElement } from 'react';

interface RequiredFieldProps {
  customMargin?: string;
  customText?: string;
}

function RequiredField({ customMargin = '3px 0', customText }: RequiredFieldProps): ReactElement {
  return <Typography.Text style={{ display: 'block', margin: customMargin }}>{customText || 'Required Field'}</Typography.Text>;
}

export default RequiredField;
